module.exports = __webpack_public_path__ + "static/media/084-ceuta.356cd1dc.svg";